import { useRouter } from 'next/router';

import PageWrapper from '.';
import Heading from '../Heading';
import Loader from '@components/Loader';
import OnPageNavigation from '../OnPageNavigation';
import { useAccount, useLocale, useTranslation } from '../../lib/hooks';
import { SiteLocale } from '@types';

export const breedersNavOptions: Record<SiteLocale, string[]> = {
  [SiteLocale.DA]: ['puppies', 'benefits'],
  [SiteLocale.EN]: ['puppies', 'benefits'],
  [SiteLocale.FI]: ['puppies', 'benefits', 'useful-info'],
  [SiteLocale.SV]: ['puppies', 'benefits'],
};

const BreedersPageWrapper = ({ children }: { children?: React.ReactNode }) => {
  const t = useTranslation();
  const locale = useLocale();
  const { push } = useRouter();
  const { account, loading } = useAccount();
  const isBreeder = account.breeder === 'verified_breeder';

  if (loading || !isBreeder) {
    if (!loading) {
      push('/');
    }

    return (
      <PageWrapper>
        <Loader />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <Heading headingSize={1}>{t('breeders.breeders_club')}</Heading>
      <OnPageNavigation
        extension="breeders-club"
        options={breedersNavOptions[locale]}
      />
      {children}
    </PageWrapper>
  );
};

export default BreedersPageWrapper;
